import React, { forwardRef } from "react";

import {
  Field,
  FieldLabel,
  FieldContent,
  FieldDescription,
  FieldError,
} from "src/primitives/Field";

interface DatePickerFieldProps {
  disabled: boolean;
  error: React.ReactNode | undefined;
  className?: string;
  label?: React.ReactNode;
  required?: boolean;
  helpText?: React.ReactNode;
  labelProps?: Record<string, unknown>;
  errorId: string;
  helpTextId: string;
  children: React.ReactNode;
}

export const DatePickerField = forwardRef<HTMLDivElement, DatePickerFieldProps>(
  (
    {
      disabled,
      error,
      className,
      label,
      required,
      helpText,
      labelProps,
      errorId,
      helpTextId,
      children,
    },
    ref
  ) => (
    <Field
      ref={ref}
      data-disabled={disabled || undefined}
      data-invalid={!!error || undefined}
      className={className}
    >
      {label && (
        <FieldLabel
          {...(labelProps as React.ComponentProps<typeof FieldLabel>)}
        >
          {label}
          {required && (
            <span aria-hidden="true" className="text-destructive">
              *
            </span>
          )}
        </FieldLabel>
      )}
      <FieldContent>
        {children}
        {!!error && <FieldError id={errorId}>{error}</FieldError>}
        {helpText && (
          <FieldDescription id={helpTextId}>{helpText}</FieldDescription>
        )}
      </FieldContent>
    </Field>
  )
);

DatePickerField.displayName = "DatePickerField";
